import artist from './artist';
import account from './account';

export default {
  artist,
  account,
};
